export default {
  data() {
    return {};
  },
  mounted() {
    window.addEventListener("resize", this.reset);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.reset);
  },
  methods: {
    reset() {
      this.chart.resize();
    }
  }
};
